// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.workshift-name[data-v-432c5a72] {\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
